import axios from 'axios';


const n = s => (s < 10 ? '0' : '') + s;
const cache = {};

const replaceTime = time => {
    const d = new Date(time);
    return [
        n(d.getFullYear()),
        n(d.getMonth() + 1),
        n(d.getDate())
    ].join('-');
};

// 消息
export const getNotices = () => {
    return axios.get('/ssc_golang/v1/user/notify/unread');
};

// 消息详情
export const getNoticeDetail = id => {
    const url = `/ssc_golang/v1/user/notify/info/${id}`;
    if (cache[url]) return cache[url];
    return axios.get(url).then(info => {
        cache[url] = info;
        return info;
    });
};



// WEBPACK FOOTER //
// ./src/service/home.js